<div class="tabs-block">
  <div class="tabs-block__header">
    <div class="tabs-block__header-item tabs-block__header-left-expanded"></div>
    <div class="tabs-block__header-item tabs-block__header-item-tabs header-item-tabs--center">
      <span class="header-item__tab" *ngFor="let tab of tabsNavLinks" routerLinkActive="header-item__tab--active">
        <a class="link link--dotted-gray-dark" [routerLink]="[tab.link]" routerLinkActive="link--no-underline">{{ tab.title }}</a>
      </span>
    </div>
    <div class="tabs-block__header-item tabs-block__header-right-expanded"></div>
  </div>
  <router-outlet></router-outlet>
</div>
